/** Compartida con el arranque del Resumen, que manda a los mismos destinos. */
const ETAPA_HREF: Record<string, string> = {
  fundacion: 'profile',
  personas: 'employees',
  matrices_vivas: 'sgsst/matriz-riesgos',
  autoevaluacion: 'sgsst',
  mejoramiento: 'sgsst/plan',
  plan_trabajo: 'plan-trabajo',
  ejecucion: 'sgsst/plan',
  cierre_sello: 'sgsst',
}

export function etapaHref(clave: string): string {
  return ETAPA_HREF[clave] ?? 'sgsst'
}
